module.exports = __webpack_public_path__ + "img/组 1.fe62a4bb.png";